export { TertiaryText } from './TertiaryText';
